import bp from './bp'
import crm from './crm'
import order from './order'
import qc from './qc'
import workbench from './workbench'
import workorder from './workorder'

export default {
  bp,
  crm,
  order,
  qc,
  workbench,
  workorder
}
